import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Tenant, TenantCreate, TenantFilter } from '../data/tenant';

export function createTenantService(client: AxiosInstance) {
  return createCrudService<Tenant, TenantCreate, TenantFilter>(client, '/Tenant', 'tenantId');
}

export type TenantService = CrudService<Tenant, TenantCreate, TenantFilter>;
